import React, { useState, useEffect, Fragment, useRef } from "react";
import logo from '../../logo.svg';
import '../../App.css';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import CoronavirusIcon from '@mui/icons-material/Coronavirus';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import makeStyles from '@mui/styles/makeStyles';
import market from '../../assets/market.svg'
import hospital from '../../assets/hospital.svg'
import outbreak from '../../assets/out.svg'
import config from '../../config.json'
import axios from 'axios';
import { Avatar, Card, CardContent, CardHeader, Chip, Divider, Grid, MenuItem, Modal, TextField, Tooltip, Backdrop } from '@mui/material';
import AreaLineChart from '../ChartComponents/AreaLineChart';
import monthyear from '../ConstantComponents/monthyear.json'
import moment from 'moment';
import IconButton from '@mui/material/IconButton';
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';
import Barchart from '../ChartComponents/Barchart';
import CloseIcon from '@mui/icons-material/Close';
import login from '../../assets/straingif.gif'


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import * as echarts from 'echarts'
import ReactECharts from 'echarts-for-react';
import NE from '../GeoJson/NE.json'
import NE2 from '../GeoJson/NE2.json'

import IND1 from '../GeoJson/IND1.json'
import IND2 from '../GeoJson/IND2.json'
import IND3 from '../GeoJson/IND3.json'
import TEST from '../GeoJson/TEST.json'

import * as maptilersdk from '@maptiler/sdk';
import "@maptiler/sdk/dist/maptiler-sdk.css";
import '../map.css'

import Sidebar from './Sidebar'
import GoogleMapHeatMap from "./GoogleMapsAPI/GoogleMapHeatMap";

import { disableBackButton } from '../ConstantComponents/Constants'
import CountUp from 'react-countup';
import CircularProgress from '@mui/material/CircularProgress';

import marketnew from '../../assets/market_new.svg'
import hosnew from '../../assets/hos_new.svg'
import ssfnew from '../../assets/ssfnew.svg'
import pawnew from '../../assets/paw.svg'

import { jwtDecode } from "jwt-decode";

import '../../customcss/loadernew.css'
import { useNavigate } from "react-router-dom";
import HeatMapComponent from "./GoogleMapsAPI/HeatMapComponent";


const BASE_URL = config.SERVER_URL;

const TITLE = config.TITLE;
const SECRET = config.SECRET;


const useStyle = makeStyles({
    root: {
        "& .MuiDataGrid-columnHeaderTitle": {
            textOverflow: "clip",
            whiteSpace: "pre-wrap",
            lineHeight: 1,
            textAlign: "center"
        },
        "& .MuiDataGrid-cellContent": {
            textOverflow: "clip",
            whiteSpace: "pre-wrap",
            lineHeight: 2,
            textAlign: "center"
        },
        boxShadow: 2,
        '& .MuiTablePagination-selectLabel': {
            marginTop: 'auto'
        },
        '& .MuiTablePagination-displayedRows': {
            marginTop: 'auto'
        },
        "& .MuiTypography-string": {
            textOverflow: "clip",
            whiteSpace: "pre-wrap",
            lineHeight: 2,
            textAlign: "center"
        },

    }
});

export default function DashboardPage() {

    disableBackButton()

    // jwt working//


    const navigate = useNavigate()
    const t1 = sessionStorage.getItem("sessionid")

    //////console.log("token from redux at enter strain page", t1)

    var decodet1 = ""

    try {
        decodet1 = jwtDecode(t1)
    } catch (error) {

    }

    useEffect(() => {
        // if (decodet1 === "") {
        //     navigate("/")
        // } else {

        //     getPrerequisits()
        // }
        getPrerequisits()
    }, [])



    //const [dataMarket, setdataMarket] = useState([])

    const [backdropopen, setbackdropopen] = useState(true)


    ////////////////////// positivity card variables ///////////////////

    const [markettotal, setmarkettotal] = useState(0)
    const [marketenteric, setmarketenteric] = useState(0)

    const [hospitaltotal, sethospitaltotal] = useState(0)
    const [hospitalenteric, sethospitalenteric] = useState(0)

    const [ssftotal, setssftotal] = useState(0)
    const [ssfenteric, setssfenteric] = useState(0)

    const [animaltotal, setanimaltotal] = useState(0)
    const [animalenteric, setanimalenteric] = useState(0)

    /////////////////// pathwise count variables ////////////////////////

    const [marketpathwise, setmarketpathwise] = useState([])
    const [hospitalpathwise, sethospitalpathwise] = useState([])
    const [ssfpathwise, setssfpathwise] = useState([])
    const [animalpathwise, setanimalpathwise] = useState([])

    const [latlong, setLatlong] = useState([])






    //maptilier init//
    const mapContainer = useRef(null);
    const map = useRef(null);
    const kolkata = { lng: 88.4308461, lat: 22.5765409 };
    const [zoom] = useState(14);
    maptilersdk.config.apiKey = 'mMlxhWYyA7DimjgmnsR0';


    // useEffect(() => {
    //     if (map.current) return; // stops map from intializing more than once

    //     map.current = new maptilersdk.Map({
    //         container: mapContainer.current,
    //         style: maptilersdk.MapStyle.STREETS,
    //         center: [kolkata.lng, kolkata.lat],
    //         zoom: zoom
    //     });

    //     new maptilersdk.Marker({ color: "#FF0000" })
    //         .setLngLat([88.43545441973149,22.568694328852978])
    //         .addTo(map.current);

    // }, [kolkata.lng, kolkata.lat, zoom]);


    //maptilier init//

    const drawerWidth = 300;

    const [mobileOpen, setMobileOpen] = React.useState(false);
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    function getPrerequisits() {

        const getPositivityCount = axios.post(BASE_URL + '/dashboard/getPositivityCard', {}, { withCredentials: true })
        const getPathWiseAll = axios.post(BASE_URL + '/dashboard/getPathWiseAll', {}, { withCredentials: true })
        //const getlatlongreq = axios.post(BASE_URL + '/dashboard/getLatLong', {}, { withCredentials: true })


        Promise.all([getPositivityCount, getPathWiseAll])
            .then(function (responses) {

                ////console.log("path data----:", responses[1].data)

                setmarkettotal(responses[0].data.TotalMarket)
                setmarketenteric(responses[0].data.EntericMarket)

                sethospitaltotal(responses[0].data.TotalHospital)
                sethospitalenteric(responses[0].data.EntericHospital)

                setssftotal(responses[0].data.TotalSSF)
                setssfenteric(responses[0].data.EntericSSF)

                setanimaltotal(responses[0].data.TotalAnimal)
                setanimalenteric(responses[0].data.EntericAnimal)


                setmarketpathwise(responses[1].data.Market)
                sethospitalpathwise(responses[1].data.Hospital)
                setssfpathwise(responses[1].data.SSF)
                setanimalpathwise(responses[1].data.Animal)







                setbackdropopen(false)


            }).catch(function (errors) {

            });

    }




    ////////////////////////////// market pathwise chart configs /////////////////


    ////console.log("market---: ", marketpathwise)

    const marketcounts = marketpathwise.map(item => item.count)
    const marketsubcatnames = marketpathwise.map(item => item.subcategoryName)

    const marketpathwisebarconfig = {
        title: {
            text: `Strains from Market Surveillance (n = ${marketenteric})`,
            show: true,
            textStyle: {
                fontSize: 25, // Custom font size
                fontFamily: 'Rubik, sans-serif', // Custom font family
                fontWeight: 500, // Custom font weight
                color: 'black',
            },
            top: 1
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: function (params) {
                let result = '<span style="font-style:italic; font-color:black;">' + params[0].axisValue + '</span>' + '<br/>';
                params.forEach(function (item) {
                    result += item.marker + item.value + '<br/>';
                });
                return result;
            },
        },
        toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'top',
            feature: {
                dataView: {
                    title: 'Table View',
                    readOnly: false,
                    lang: ['<div style="margin-bottom: 5px"><center>TABLE VIEW</center></div>', 'Close', 'Refresh'],
                    optionToContent: function (opt) {
                        var axisData = opt.xAxis[0].data;
                        var series = opt.series;
                        var table = '<center><table style="width:85%;text-align:center;border: 2px solid #000000; border-radius: 10px"><thead><tr>'
                            + '<th style="background-color: #bbbdbd; padding: 10px; border: 1px solid #000000; ">Pathogens</th>'
                            + series.map(function (item) {
                                return '<th style="background-color: #bbbdbd; border: 1px solid #000000;">' + item.name + '</th>';
                            }).join('')
                            + '</tr></thead><tbody>';

                        for (var i = 0, l = axisData.length; i < l; i++) {
                            var rowColor = i % 2 === 0 ? '#ffffff' : '#e8eded';
                            table += '<tr style="background-color: ' + rowColor + '; padding: 20px; border: 1px solid #000000;">'
                                + '<td style=" padding: 5px; border: 1px solid #000000; ">' + axisData[i] + '</td>'
                                + series.map(function (item) {
                                    return '<td style="border: 1px solid #000000;">' + (item.data[i] || '0') + '</td>';
                                }).join('')
                                + '</tr>';
                        }

                        table += '</tbody></table></center>';
                        return table;
                    }
                },
                saveAsImage: {}
            }
        },
        legend: {},
        grid: {
            left: '0.5%',
            right: '0%',
            bottom: '1%',
            containLabel: true
        },
        yAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLabel: {
                fontSize: 15,
                fontWeight: 600,
                color: '#000000'
            },

        },
        xAxis: {
            type: 'category',
            data: marketsubcatnames,
            axisTick: {
                alignWithLabel: true
            },
            axisLabel: {
                fontSize: 15,
                fontFamily: 'Rubik, sans-serif',
                fontWeight: 600,
                color: 'black',
                interval: 0,
                padding: [5, 0, 0, 0],
                formatter: function (value, index) {

                    return value.split(' ').join('\n'); // Split labels by space into multiple lines



                },
                ellipsis: true,
                rotate: 0,
                margin: 25,
                fontStyle: 'italic'
                // formatter: function (value) {
                //     return value.length > 10 ? value.slice(0, 10) + '...' : value;
                //   }


            }
        },
        series: [
            {

                type: 'bar',
                barWidth: '20%',
                data: marketcounts,
                showBackground: true,
                label: {
                    show: true,
                    position: 'top',
                    fontSize: 15,
                    fontWeight: 600,
                }
            }
        ],
        height: 320
        // dataZoom: [{
        //     type: 'slider',
        //     show: true,
        //     start: 2,
        //     end: minLabel,
        //     handleSize: '150%',

        // }],

    };

    ////////////////////////////// hospital pathwise chart configs /////////////////


    ////console.log("market---: ", hospitalpathwise)

    const hospitalcounts = hospitalpathwise.map(item => item.count)
    const hospitalsubcatnames = hospitalpathwise.map(item => item.subcategoryName)


    const hospitalpathwisebarconfig = {
        title: {
            text: `Strains from Hospital Surveillance (n = ${hospitalenteric})`,
            show: true,
            textStyle: {
                fontSize: 25, // Custom font size
                fontFamily: 'Rubik, sans-serif', // Custom font family
                fontWeight: 500, // Custom font weight
                color: 'black',
            },
            top: 1
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: function (params) {
                let result = '<span style="font-style:italic; font-color:black;">' + params[0].axisValue + '</span>' + '<br/>';
                params.forEach(function (item) {
                    result += item.marker + item.value + '<br/>';
                });
                return result;
            },
        },
        toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'top',
            feature: {
                dataView: {
                    title: 'Table View',
                    readOnly: false,
                    lang: ['<div style="margin-bottom: 5px"><center>TABLE VIEW</center></div>', 'Close', 'Refresh'],
                    optionToContent: function (opt) {
                        var axisData = opt.xAxis[0].data;
                        var series = opt.series;
                        var table = '<center><table style="width:85%;text-align:center;border: 2px solid #000000; border-radius: 10px"><thead><tr>'
                            + '<th style="background-color: #bbbdbd; padding: 10px; border: 1px solid #000000; ">Pathogens</th>'
                            + series.map(function (item) {
                                return '<th style="background-color: #bbbdbd; border: 1px solid #000000;">' + item.name + '</th>';
                            }).join('')
                            + '</tr></thead><tbody>';

                        for (var i = 0, l = axisData.length; i < l; i++) {
                            var rowColor = i % 2 === 0 ? '#ffffff' : '#e8eded';
                            table += '<tr style="background-color: ' + rowColor + '; padding: 20px; border: 1px solid #000000;">'
                                + '<td style=" padding: 5px; border: 1px solid #000000; ">' + axisData[i] + '</td>'
                                + series.map(function (item) {
                                    return '<td style="border: 1px solid #000000;">' + (item.data[i] || '0') + '</td>';
                                }).join('')
                                + '</tr>';
                        }

                        table += '</tbody></table></center>';
                        return table;
                    }
                },
                saveAsImage: {}
            }
        },
        legend: {},
        grid: {
            left: '0.5%',
            right: '0%',
            bottom: '1%',
            containLabel: true
        },
        yAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLabel: {
                fontSize: 15,
                fontWeight: 600,
                color: '#000000'
            },

        },
        xAxis: {
            type: 'category',
            data: hospitalsubcatnames,
            axisTick: {
                alignWithLabel: true
            },
            axisLabel: {
                fontSize: 15,
                fontFamily: 'Rubik, sans-serif',
                fontWeight: 600,
                color: 'black',
                interval: 0,
                padding: [5, 0, 0, 0],
                formatter: function (value, index) {

                    return value.split(' ').join('\n'); // Split labels by space into multiple lines



                },
                ellipsis: true,
                rotate: 0,
                margin: 25,
                fontStyle: 'italic'
                // formatter: function (value) {
                //     return value.length > 10 ? value.slice(0, 10) + '...' : value;
                //   }


            }
        },
        series: [
            {

                type: 'bar',
                barWidth: '20%',
                data: hospitalcounts,
                showBackground: true,
                label: {
                    show: true,
                    position: 'top',
                    fontSize: 15,
                    fontWeight: 600,
                },
                itemStyle: {
                    color: '#00e8d1', // Set the bar color to tomato red
                },
            }
        ],
        height: 320
        // dataZoom: [{
        //     type: 'slider',
        //     show: true,
        //     start: 2,
        //     end: minLabel,
        //     handleSize: '150%',

        // }],

    };

    ////////////////////////////// ssf pathwise chart configs /////////////////

    const ssfcounts = ssfpathwise.map(item => item.count)
    const ssfsubcatnames = ssfpathwise.map(item => item.subcategoryName)


    const ssfpathwisebarconfig = {
        title: {
            text: `Strains from SSF Surveillance (n = ${ssfenteric})`,
            show: true,
            textStyle: {
                fontSize: 25, // Custom font size
                fontFamily: 'Rubik, sans-serif', // Custom font family
                fontWeight: 500, // Custom font weight
                color: 'black',
            },
            top: 1
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: function (params) {
                let result = '<span style="font-style:italic; font-color:black;">' + params[0].axisValue + '</span>' + '<br/>';
                params.forEach(function (item) {
                    result += item.marker + item.value + '<br/>';
                });
                return result;
            },
        },
        toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'top',
            feature: {
                dataView: {
                    title: 'Table View',
                    readOnly: false,
                    lang: ['<div style="margin-bottom: 5px"><center>TABLE VIEW</center></div>', 'Close', 'Refresh'],
                    optionToContent: function (opt) {
                        var axisData = opt.xAxis[0].data;
                        var series = opt.series;
                        var table = '<center><table style="width:85%;text-align:center;border: 2px solid #000000; border-radius: 10px"><thead><tr>'
                            + '<th style="background-color: #bbbdbd; padding: 10px; border: 1px solid #000000; ">Pathogens</th>'
                            + series.map(function (item) {
                                return '<th style="background-color: #bbbdbd; border: 1px solid #000000;">' + item.name + '</th>';
                            }).join('')
                            + '</tr></thead><tbody>';

                        for (var i = 0, l = axisData.length; i < l; i++) {
                            var rowColor = i % 2 === 0 ? '#ffffff' : '#e8eded';
                            table += '<tr style="background-color: ' + rowColor + '; padding: 20px; border: 1px solid #000000;">'
                                + '<td style=" padding: 5px; border: 1px solid #000000; ">' + axisData[i] + '</td>'
                                + series.map(function (item) {
                                    return '<td style="border: 1px solid #000000;">' + (item.data[i] || '0') + '</td>';
                                }).join('')
                                + '</tr>';
                        }

                        table += '</tbody></table></center>';
                        return table;
                    }
                },
                saveAsImage: {}
            }
        },
        legend: {},
        grid: {
            left: '0.5%',
            right: '0%',
            bottom: '1%',
            containLabel: true
        },
        yAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLabel: {
                fontSize: 15,
                fontWeight: 600,
                color: '#000000'
            },

        },
        xAxis: {
            type: 'category',
            data: ssfsubcatnames,
            axisTick: {
                alignWithLabel: true
            },
            axisLabel: {
                fontSize: 15,
                fontFamily: 'Rubik, sans-serif',
                fontWeight: 600,
                color: 'black',
                interval: 0,
                padding: [5, 0, 0, 0],
                formatter: function (value, index) {

                    return value.split(' ').join('\n'); // Split labels by space into multiple lines



                },
                ellipsis: true,
                rotate: 0,
                margin: 25,
                fontStyle: 'italic'
                // formatter: function (value) {
                //     return value.length > 10 ? value.slice(0, 10) + '...' : value;
                //   }


            }
        },
        series: [
            {

                type: 'bar',
                barWidth: '20%',
                data: ssfcounts,
                showBackground: true,
                label: {
                    show: true,
                    position: 'top',
                    fontSize: 15,
                    fontWeight: 600,
                },
                itemStyle: {
                    color: '#4ce096', // Set the bar color to tomato red
                },
            }
        ],
        height: 320
        // dataZoom: [{
        //     type: 'slider',
        //     show: true,
        //     start: 2,
        //     end: minLabel,
        //     handleSize: '150%',

        // }],

    };

    ////////////////////////////// animal pathwise chart configs /////////////////

    const animalcounts = animalpathwise.map(item => item.count)
    const animalsubcatnames = animalpathwise.map(item => item.subcategoryName)


    const animalpathwisebarconfig = {
        title: {
            text: `Strains from Animal Surveillance (n = ${animalenteric})`,
            show: true,
            textStyle: {
                fontSize: 25, // Custom font size
                fontFamily: 'Rubik, sans-serif', // Custom font family
                fontWeight: 500, // Custom font weight
                color: 'black',
            },
            top: 1
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: function (params) {
                let result = '<span style="font-style:italic; font-color:black;">' + params[0].axisValue + '</span>' + '<br/>';
                params.forEach(function (item) {
                    result += item.marker + item.value + '<br/>';
                });
                return result;
            },
        },
        toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'top',
            feature: {
                dataView: {
                    title: 'Table View',
                    readOnly: false,
                    lang: ['<div style="margin-bottom: 5px"><center>TABLE VIEW</center></div>', 'Close', 'Refresh'],
                    optionToContent: function (opt) {
                        var axisData = opt.xAxis[0].data;
                        var series = opt.series;
                        var table = '<center><table style="width:85%;text-align:center;border: 2px solid #000000; border-radius: 10px"><thead><tr>'
                            + '<th style="background-color: #bbbdbd; padding: 10px; border: 1px solid #000000; ">Pathogens</th>'
                            + series.map(function (item) {
                                return '<th style="background-color: #bbbdbd; border: 1px solid #000000;">' + item.name + '</th>';
                            }).join('')
                            + '</tr></thead><tbody>';

                        for (var i = 0, l = axisData.length; i < l; i++) {
                            var rowColor = i % 2 === 0 ? '#ffffff' : '#e8eded';
                            table += '<tr style="background-color: ' + rowColor + '; padding: 20px; border: 1px solid #000000;">'
                                + '<td style=" padding: 5px; border: 1px solid #000000; ">' + axisData[i] + '</td>'
                                + series.map(function (item) {
                                    return '<td style="border: 1px solid #000000;">' + (item.data[i] || '0') + '</td>';
                                }).join('')
                                + '</tr>';
                        }

                        table += '</tbody></table></center>';
                        return table;
                    }
                },
                saveAsImage: {}
            }
        },
        legend: {},
        grid: {
            left: '0.5%',
            right: '0%',
            bottom: '1%',
            containLabel: true
        },
        yAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLabel: {
                fontSize: 15,
                fontWeight: 600,
                color: '#000000'
            },

        },
        xAxis: {
            type: 'category',
            data: animalsubcatnames,
            axisTick: {
                alignWithLabel: true
            },
            axisLabel: {
                fontSize: 15,
                fontFamily: 'Rubik, sans-serif',
                fontWeight: 600,
                color: 'black',
                interval: 0,
                padding: [5, 0, 0, 0],
                formatter: function (value, index) {

                    return value.split(' ').join('\n'); // Split labels by space into multiple lines



                },
                ellipsis: true,
                rotate: 0,
                margin: 25,
                fontStyle: 'italic'
                // formatter: function (value) {
                //     return value.length > 10 ? value.slice(0, 10) + '...' : value;
                //   }


            }
        },
        series: [
            {

                type: 'bar',
                barWidth: '20%',
                data: animalcounts,
                showBackground: true,
                label: {
                    show: true,
                    position: 'top',
                    fontSize: 15,
                    fontWeight: 600,
                },
                itemStyle: {
                    color: '#ee6666', // Set the bar color to tomato red
                },
            }
        ],
        height: 320
        // dataZoom: [{
        //     type: 'slider',
        //     show: true,
        //     start: 2,
        //     end: minLabel,
        //     handleSize: '150%',

        // }],

    };










    return (
        <>



            <Box
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                    backgroundColor: '#f3f4f7',
                    scrollbarWidth: 'none', // For Firefox
                    msOverflowStyle: 'none', // For Internet Explorer and Edge
                    '&::WebkitScrollbar': {
                        display: 'none', // For Chrome, Safari, and Edge
                    },
                }}>


                <Sidebar />

                <HeatMapComponent/>

                {/*<div style={{ marginTop: '100px', marginLeft: "15px", marginBottom: "100px" }}>*/}

                {/*    <Box component="main" sx={{ p: 1, backgroundColor: '#f3f4f7' }}>*/}

                {/*        <Grid container spacing={3} sx={{ marginTop: '5px', paddingLeft: 1, paddingRight: 1 }} >*/}

                {/*            <Grid item xs={12} sm={12} md={12} lg={6} marginTop={4} >*/}
                {/*                <div style={{*/}
                {/*                    backgroundColor: '#ffffff', borderRadius: '5px', padding: '20px',*/}
                {/*                    marginLeft: '10px', width: '100%', alignItems: 'center', display: 'flex',*/}
                {/*                    position: 'relative', justifyContent: 'center', flexDirection: 'column',*/}
                {/*                    border: '2px solid'*/}
                {/*                }}>*/}
                {/*                    <Avatar*/}
                {/*                        alt="market"*/}
                {/*                        src={marketnew}*/}
                {/*                        sx={{*/}
                {/*                            width: 100, height: 100, bgcolor: "#d7e8fc", padding: '15px',*/}
                {/*                            position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center', top: '-45px',*/}
                {/*                        }}*/}
                {/*                    />*/}
                {/*                    <div style={{ marginTop: '50px' }}>*/}
                {/*                        <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Samples Tested</h5>*/}
                {/*                        <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>from</h5>*/}
                {/*                        <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Market Surveillance</h5>*/}
                {/*                        <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center', marginTop: '15px' }}><CountUp end={markettotal} /></h3>*/}

                {/*                    </div>*/}
                {/*                    <div className="row" style={{ width: '100%' }}>*/}
                {/*                        <Divider orientation="horizontal" sx={{ backgroundColor: 'blue', height: 1 }}></Divider>*/}
                {/*                    </div>*/}

                {/*                    <div className="container" style={{ width: '100%', alignItems: 'center', justifyContent: 'space-around', display: 'flex', flexDirection: 'row', marginTop: '10px' }}>*/}
                {/*                        <div className="row">*/}
                {/*                            <h5 style={{ textAlign: 'center', fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Enteric Pathogens</h5>*/}

                {/*                            <h4 style={{ textAlign: 'center', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}><CountUp end={marketenteric} /></h4>*/}

                {/*                        </div>*/}
                {/*                        <div>*/}
                {/*                            <h5 style={{ textAlign: 'center', fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Positivity Rate</h5>*/}
                {/*                            <h4 style={{ textAlign: 'center', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'red' }}>{(marketenteric / markettotal * 100).toFixed(2)}%</h4>*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                    /!* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> *!/*/}

                {/*                </div>*/}
                {/*            </Grid>*/}
                {/*            <Grid item xs={12} sm={12} md={12} lg={6} marginTop={4} >*/}
                {/*                <div style={{*/}
                {/*                    backgroundColor: '#ffffff', borderRadius: '5px', padding: '20px',*/}
                {/*                    marginLeft: '10px', width: '100%', alignItems: 'center', display: 'flex',*/}
                {/*                    position: 'relative', justifyContent: 'center', flexDirection: 'column',*/}
                {/*                    border: '2px solid'*/}
                {/*                }}>*/}
                {/*                    <Avatar*/}
                {/*                        alt="market"*/}
                {/*                        src={hosnew}*/}
                {/*                        sx={{*/}
                {/*                            width: 100, height: 100, bgcolor: "#d7e8fc", padding: '15px',*/}
                {/*                            position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center', top: '-45px',*/}
                {/*                        }}*/}
                {/*                    />*/}
                {/*                    <div style={{ marginTop: '50px' }}>*/}
                {/*                        <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Samples Tested</h5>*/}
                {/*                        <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>from</h5>*/}
                {/*                        <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Hospital Surveillance</h5>*/}
                {/*                        <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center', marginTop: '15px' }}><CountUp end={hospitaltotal} /></h3>*/}

                {/*                    </div>*/}
                {/*                    <div className="row" style={{ width: '100%' }}>*/}
                {/*                        <Divider orientation="horizontal" sx={{ backgroundColor: 'blue', height: 1 }}></Divider>*/}
                {/*                    </div>*/}

                {/*                    <div className="container" style={{ width: '100%', alignItems: 'center', justifyContent: 'space-around', display: 'flex', flexDirection: 'row', marginTop: '10px' }}>*/}
                {/*                        <div className="row">*/}
                {/*                            <h5 style={{ textAlign: 'center', fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Enteric Pathogens</h5>*/}
                {/*                            <h4 style={{ textAlign: 'center', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>{hospitalenteric}</h4>*/}

                {/*                        </div>*/}
                {/*                        <div>*/}
                {/*                            <h5 style={{ textAlign: 'center', fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Positivity Rate</h5>*/}
                {/*                            <h4 style={{ textAlign: 'center', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'red' }}>{(hospitalenteric / hospitaltotal * 100).toFixed(2)}%</h4>*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                    /!* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> *!/*/}

                {/*                </div>*/}
                {/*            </Grid>*/}
                {/*            <Grid item xs={12} sm={12} md={12} lg={6} marginTop={4} >*/}
                {/*                <div style={{*/}
                {/*                    backgroundColor: '#ffffff', borderRadius: '5px', padding: '20px',*/}
                {/*                    marginLeft: '10px', width: '100%', alignItems: 'center', display: 'flex',*/}
                {/*                    position: 'relative', justifyContent: 'center', flexDirection: 'column',*/}
                {/*                    border: '2px solid'*/}
                {/*                }}>*/}
                {/*                    <Avatar*/}
                {/*                        alt="market"*/}
                {/*                        src={ssfnew}*/}
                {/*                        sx={{*/}
                {/*                            width: 100, height: 100, bgcolor: "#d7e8fc", padding: '15px',*/}
                {/*                            position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center', top: '-45px',*/}
                {/*                        }}*/}
                {/*                    />*/}
                {/*                    <div style={{ marginTop: '50px' }}>*/}
                {/*                        <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Samples Tested</h5>*/}
                {/*                        <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>from</h5>*/}
                {/*                        <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>SSF Surveillance</h5>*/}
                {/*                        <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center', marginTop: '15px' }}><CountUp end={ssftotal} /></h3>*/}

                {/*                    </div>*/}
                {/*                    <div className="row" style={{ width: '100%' }}>*/}
                {/*                        <Divider orientation="horizontal" sx={{ backgroundColor: 'blue', height: 1 }}></Divider>*/}
                {/*                    </div>*/}

                {/*                    <div className="container" style={{ width: '100%', alignItems: 'center', justifyContent: 'space-around', display: 'flex', flexDirection: 'row', marginTop: '10px' }}>*/}
                {/*                        <div className="row">*/}
                {/*                            <h5 style={{ textAlign: 'center', fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Enteric Pathogens</h5>*/}
                {/*                            <h4 style={{ textAlign: 'center', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>{ssfenteric}</h4>*/}

                {/*                        </div>*/}
                {/*                        <div>*/}
                {/*                            <h5 style={{ textAlign: 'center', fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Positivity Rate</h5>*/}
                {/*                            <h4 style={{ textAlign: 'center', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'red' }}>{(ssfenteric / ssftotal * 100).toFixed(2)}%</h4>*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                    /!* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> *!/*/}

                {/*                </div>*/}
                {/*            </Grid>*/}
                {/*            <Grid item xs={12} sm={12} md={12} lg={6} marginTop={4} >*/}
                {/*                <div style={{*/}
                {/*                    backgroundColor: '#ffffff', borderRadius: '5px', padding: '20px',*/}
                {/*                    marginLeft: '10px', width: '100%', alignItems: 'center', display: 'flex',*/}
                {/*                    position: 'relative', justifyContent: 'center', flexDirection: 'column',*/}
                {/*                    border: '2px solid'*/}
                {/*                }}>*/}
                {/*                    <Avatar*/}
                {/*                        alt="market"*/}
                {/*                        src={pawnew}*/}
                {/*                        sx={{*/}
                {/*                            width: 100, height: 100, bgcolor: "#d7e8fc", padding: '15px',*/}
                {/*                            position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center', top: '-45px',*/}
                {/*                        }}*/}
                {/*                    />*/}
                {/*                    <div style={{ marginTop: '50px' }}>*/}
                {/*                        <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Samples Tested</h5>*/}
                {/*                        <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>from</h5>*/}
                {/*                        <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Animal Surveillance</h5>*/}
                {/*                        <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center', marginTop: '15px' }}><CountUp end={animaltotal} /></h3>*/}

                {/*                    </div>*/}
                {/*                    <div className="row" style={{ width: '100%' }}>*/}
                {/*                        <Divider orientation="horizontal" sx={{ backgroundColor: 'blue', height: 1 }}></Divider>*/}
                {/*                    </div>*/}

                {/*                    <div className="container" style={{ width: '100%', alignItems: 'center', justifyContent: 'space-around', display: 'flex', flexDirection: 'row', marginTop: '10px' }}>*/}
                {/*                        <div className="row">*/}
                {/*                            <h5 style={{ textAlign: 'center', fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Enteric Pathogens</h5>*/}
                {/*                            <h4 style={{ textAlign: 'center', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>{animalenteric}</h4>*/}

                {/*                        </div>*/}
                {/*                        <div>*/}
                {/*                            <h5 style={{ textAlign: 'center', fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Positivity Rate</h5>*/}
                {/*                            <h4 style={{ textAlign: 'center', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'red' }}>{(animalenteric / animaltotal * 100).toFixed(2)}%</h4>*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                    /!* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> *!/*/}

                {/*                </div>*/}
                {/*            </Grid>*/}

                {/*        </Grid>*/}

                {/*        <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} >*/}
                {/*            <Grid item xs={12} sm={12} md={12} lg={12}>*/}
                {/*                <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >*/}
                {/*                    /!* <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Strains identified by NICED & RMRC-NE</h3> *!/*/}
                {/*                    /!* <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Strains Uploaded by Respective Centers</h5> *!/*/}
                {/*                    <ReactECharts option={marketpathwisebarconfig} style={{ height: '400px', width: '100%' }} />*/}


                {/*                </div>*/}
                {/*            </Grid>*/}
                {/*        </Grid>*/}

                {/*        <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} >*/}
                {/*            <Grid item xs={12} sm={12} md={12} lg={12}>*/}
                {/*                <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >*/}
                {/*                    /!* <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Strains identified by NICED & RMRC-NE</h3> *!/*/}
                {/*                    /!* <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Strains Uploaded by Respective Centers</h5> *!/*/}
                {/*                    <ReactECharts option={hospitalpathwisebarconfig} style={{ height: '400px', width: '100%' }} />*/}


                {/*                </div>*/}
                {/*            </Grid>*/}
                {/*        </Grid>*/}

                {/*        <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} >*/}
                {/*            <Grid item xs={12} sm={12} md={12} lg={12}>*/}
                {/*                <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >*/}
                {/*                    /!* <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Strains identified by NICED & RMRC-NE</h3> *!/*/}
                {/*                    /!* <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Strains Uploaded by Respective Centers</h5> *!/*/}
                {/*                    <ReactECharts option={ssfpathwisebarconfig} style={{ height: '400px', width: '100%' }} />*/}


                {/*                </div>*/}
                {/*            </Grid>*/}
                {/*        </Grid>*/}

                {/*        <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} >*/}
                {/*            <Grid item xs={12} sm={12} md={12} lg={12}>*/}
                {/*                <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >*/}
                {/*                    /!* <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Strains identified by NICED & RMRC-NE</h3> *!/*/}
                {/*                    /!* <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Strains Uploaded by Respective Centers</h5> *!/*/}
                {/*                    <ReactECharts option={animalpathwisebarconfig} style={{ height: '400px', width: '100%' }} />*/}


                {/*                </div>*/}
                {/*            </Grid>*/}
                {/*        </Grid>*/}




                {/*    </Box>*/}




                {/*</div>*/}
            </Box>




            <Backdrop
                sx={{ color: "#000000", zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: 'rgba(255,255,255,0.9)' }}
                open={backdropopen}
            >
                {/* <CircularProgress color="inherit" /> */}

                <div className="boxes">
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </Backdrop>

        </>
    )
}
